'use client';

import { useCallback } from 'react';

import { useSidebar } from '@/components/ui/sidebar';
import { useZenModeStore } from '@/lib/stores/zen-mode-store';

export function useZenModeToggle() {
  const { isZenMode, toggleZenMode, preZenState, setPreZenState } = useZenModeStore();
  const { open: rightSidebarOpen, setOpen: setRightSidebarOpen, isMobile } = useSidebar();

  const toggle = useCallback(() => {
    if (!isZenMode) {
      // Save the right sidebar state before entering zen mode.
      // File tree and left sidebar collapse visually via CSS
      // driven by isZenMode in the Zustand store — no state change needed.
      setPreZenState({
        rightSidebarOpen: isMobile ? false : rightSidebarOpen,
      });

      if (!isMobile && rightSidebarOpen) {
        setRightSidebarOpen(false);
      }
    } else {
      if (preZenState) {
        if (!isMobile) {
          setRightSidebarOpen(preZenState.rightSidebarOpen);
        }
        setPreZenState(null);
      }
    }

    toggleZenMode();
  }, [
    isZenMode,
    toggleZenMode,
    preZenState,
    setPreZenState,
    rightSidebarOpen,
    setRightSidebarOpen,
    isMobile,
  ]);

  return { isZenMode, toggle };
}
